import { defineMessages } from 'react-intl';

export default defineMessages({
  notMatchingCriteria: 'Wybrana osoba nie spełnia kryteriów jednego z wybranych kwestionariuszy',
});
